/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';

/**
 *
 * @export
 * @interface ConversationalAgentGenerationInputsCreate
 */
export interface ConversationalAgentGenerationInputsCreate {
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof ConversationalAgentGenerationInputsCreate
   */
  language: ConversationalAgentLanguageEnum;
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentGenerationInputsCreate
   */
  nSamples: number;
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentGenerationInputsCreate
   */
  seedDataset: number;
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentGenerationInputsCreate
   */
  inferencerId: number;
}

/**
 * Check if a given object implements the ConversationalAgentGenerationInputsCreate interface.
 */
export function instanceOfConversationalAgentGenerationInputsCreate(
  value: object,
): value is ConversationalAgentGenerationInputsCreate {
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('nSamples' in value) || value['nSamples'] === undefined) return false;
  if (!('seedDataset' in value) || value['seedDataset'] === undefined) return false;
  if (!('inferencerId' in value) || value['inferencerId'] === undefined) return false;
  return true;
}

export function ConversationalAgentGenerationInputsCreateFromJSON(
  json: any,
): ConversationalAgentGenerationInputsCreate {
  return ConversationalAgentGenerationInputsCreateFromJSONTyped(json, false);
}

export function ConversationalAgentGenerationInputsCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentGenerationInputsCreate {
  if (json == null) {
    return json;
  }
  return {
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
    nSamples: json['n_samples'],
    seedDataset: json['seed_dataset'],
    inferencerId: json['inferencer_id'],
  };
}

export function ConversationalAgentGenerationInputsCreateToJSON(
  value?: ConversationalAgentGenerationInputsCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
    n_samples: value['nSamples'],
    seed_dataset: value['seedDataset'],
    inferencer_id: value['inferencerId'],
  };
}
